exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.workflow-row-details .active {\n  text-decoration: none;\n  color: #ffffff;\n  background: #f4a93f;\n}\n.addCheck {\n    background-color: aliceblue;\n}\n", ""]);

// exports
